import { NxObject } from './models/nx-object';

export class NxObjectService {
	static isGrayedAndItalicized(nxObject: NxObject) {
		return nxObject.hasInheritedAssignedTitles;
	}
}
